module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(withChooseExtent) {;
__p += '\n<div id="DescartesRequestManagerChooseExtent">\n  ' +
((__t = (labelSearchExtent)) == null ? '' : __t) +
'\n  <div class="form-check">\n    <input class="form-check-input" type="radio" name="DescartesRequestFlexRadio" id="DescartesRequestFlexRadio1" value="1" checked>\n    <label class="form-check-label" for="DescartesRequestFlexRadio1">\n        ' +
((__t = (labelExtentGlobal)) == null ? '' : __t) +
'\n    </label>\n  </div>\n  <div class="form-check">\n    <input class="form-check-input" type="radio" name="DescartesRequestFlexRadio" id="DescartesRequestFlexRadio2" value="2">\n    <label class="form-check-label" for="DescartesRequestFlexRadio2">\n        ' +
((__t = (labelExtentCurrent)) == null ? '' : __t) +
'\n    </label>\n  </div>\n  <div class="form-check">\n    <input class="form-check-input" type="radio" name="DescartesRequestFlexRadio" id="DescartesRequestFlexRadio3" value="3">\n    <label class="form-check-label" for="DescartesRequestFlexRadio3">\n      <div id="DescartesRequestManagerEntityeAdmin">' +
((__t = (labelExtentEntity)) == null ? '' : __t) +
'</div>\n      <div id="DescartesRequestManagerEntityeAdminChoosed"></div>\n    </label>\n    <button id="DescartesRequestManagerChooseBtn" type="button" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">Choisir</button>\n\n    <div id="DescartesRequestManagerGazetteer"></div>\n  </div>\n</div>\n    \n</br>\n  ' +
((__t = (labelFilterLayer)) == null ? '' : __t) +
'\n<select class="DescartesUISelect form-control" id="DescartesRequestsSelect">\n   ';
_.each(requests,function(request,index) {;
__p += '\n   <option value="#DescartesRequestTab_' +
((__t = (index)) == null ? '' : __t) +
'">' +
((__t = (request.title)) == null ? '' : __t) +
'</option>\n   ';
});;
__p += '\n</select>\n<hr>\n<ul class="nav nav-tabs" id="DescartesRequestsTab" style="display:none;">\n';
 _.each(requests,function(request,index) {
     var activeClass = '';
     if (index === 0) {
         activeClass = "active";
     }
 ;
__p += '\n    <li class="' +
((__t = (activeClass)) == null ? '' : __t) +
'"><a href="#DescartesRequestTab_' +
((__t = (index)) == null ? '' : __t) +
'">DescartesRequestTab_' +
((__t = (index)) == null ? '' : __t) +
'</a></li>\n ';
});;
__p += '\n</ul>\n\n<div class="tab-content">\n ';
_.each(requests,function(request,index) {
     var activeClass = '';
     if (index === 0) {
         activeClass = "active";
     }
     var formId = 'DescartesUIRequest_' + index;
 ;
__p += '\n  <div class="tab-pane ' +
((__t = (activeClass)) == null ? '' : __t) +
'" id="DescartesRequestTab_' +
((__t = (index)) == null ? '' : __t) +
'">\n\n<form class="form-horizontal" id="' +
((__t = (formId)) == null ? '' : __t) +
'">\n\n    ';
 _.each(request.members,function(member,index) {
        if(member.visible) {
    ;
__p += '\n    <div class="form-group row">\n        <label class="DescartesUILabel col-md-4 col-lg-6 col-form-label">' +
((__t = (member.title)) == null ? '' : __t) +
'</label>\n        <div class="col-md-8 col-lg-6">\n            ';
 if(member.list) {;
__p += '\n            <select class="DescartesUISelect form-control" name="memberSelect_' +
((__t = (index)) == null ? '' : __t) +
'">\n                <option value="null">' +
((__t = (inactiveSelectTitle)) == null ? '' : __t) +
'</option>\n                ';
_.each(member.value,function(value) {;
__p += '\n                <option value="' +
((__t = (value)) == null ? '' : __t) +
'">' +
((__t = (value)) == null ? '' : __t) +
'</option>\n                ';
});;
__p += '\n            </select>\n            ';
 } else { ;
__p += '\n            <input type="text" class="DescartesUIInput form-control" name="memberText_' +
((__t = (index)) == null ? '' : __t) +
'"></input>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n    ';
}});;
__p += '\n    <button type="submit" id="DescartesRequestTabButtonSummit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
' DescartesRequestTabButtonSummit">' +
((__t = (buttonMessageRecherche)) == null ? '' : __t) +
'</button>\n\n</form>\n\n\n  </div>\n     ';
});;
__p += '\n</div>\n<hr/>\n';
} else {;
__p += '\n\n';
 _.each(requests,function(request,index) {
    var formId = 'DescartesUIRequest_' + index;
;
__p += '\n\n<form class="form-horizontal" id="' +
((__t = (formId)) == null ? '' : __t) +
'">\n    <h4 class="DescartesUIRequestTitle text-center">' +
((__t = (request.title)) == null ? '' : __t) +
'</h4>\n    ';
 _.each(request.members,function(member,index) {
        if(member.visible) {
    ;
__p += '\n    <div class="form-group row">\n        <label class="DescartesUILabel col-md-4 col-lg-6 col-form-label">' +
((__t = (member.title)) == null ? '' : __t) +
'</label>\n        <div class="col-md-8 col-lg-6">\n            ';
 if(member.list) {;
__p += '\n            <select class="DescartesUISelect form-control" name="memberSelect_' +
((__t = (index)) == null ? '' : __t) +
'">\n                <option value="null">' +
((__t = (inactiveSelectTitle)) == null ? '' : __t) +
'</option>\n                ';
_.each(member.value,function(value) {;
__p += '\n                <option value="' +
((__t = (value)) == null ? '' : __t) +
'">' +
((__t = (value)) == null ? '' : __t) +
'</option>\n                ';
});;
__p += '\n            </select>\n            ';
 } else { ;
__p += '\n            <input type="text" class="DescartesUIInput form-control" name="memberText_' +
((__t = (index)) == null ? '' : __t) +
'"></input>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n    ';
}});;
__p += '\n    <div class="row">\n      <div class="col-6">\n    <div class="text-left">\n        <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageRecherche)) == null ? '' : __t) +
'</button>\n    </div>\n      </div>\n      <div class="col-6">\n        <div class="form-check">\n           <input class="form-check-input" type="checkbox" value="false" id="DescartesRequestCheckBox_' +
((__t = (index)) == null ? '' : __t) +
'" />\n           <label class="form-check-label" for="DescartesRequestCheckBox_' +
((__t = (index)) == null ? '' : __t) +
'">Lancer la recherche sur l\'emprise courante</label>\n        </div>\n      </div>\n    </div>\n    ';
 if(separateur===true) { ;
__p += '\n    <hr/>\n    ';
 } ;
__p += '\n</form>\n';
 }); ;
__p += '\n';
};
__p += '\n<div class="dropup">\n  <button class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
' dropdown-toggle" type="button" id="DescartesRequestDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="' +
((__t = (buttonMessageActionsTooltip)) == null ? '' : __t) +
'">\n    ' +
((__t = (buttonMessageActions)) == null ? '' : __t) +
'\n  </button>\n  <div class="dropdown-menu" aria-labelledby="DescartesRequestDropdownMenu">\n    <button class="dropdown-item" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesRequestAddSelectionLayer" title="' +
((__t = (buttonMessageAddSelectionLayerTooltip)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageAddSelectionLayer)) == null ? '' : __t) +
'</button>\n    <button class="dropdown-item" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesRequestFixSelectionLayer" title="' +
((__t = (buttonMessageFixSelectionLayerTooltip)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageFixSelectionLayer)) == null ? '' : __t) +
'</button>\n    <button class="dropdown-item" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesRequestFlashSelectionLayer" title="' +
((__t = (buttonMessageFlashSelectionLayerTooltip)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageFlashSelectionLayer)) == null ? '' : __t) +
'</button>\n    <button class="dropdown-item" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesRequestUndisplaySelectionLayer" title="' +
((__t = (buttonMessageUndisplaySelectionLayerTooltip)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageUndisplaySelectionLayer)) == null ? '' : __t) +
'</button>\n    <button class="dropdown-item" type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesRequestUnselectRequest" title="' +
((__t = (buttonMessageUnselectTooltip)) == null ? '' : __t) +
'">' +
((__t = (buttonMessageUnselect)) == null ? '' : __t) +
'</button>\n  </div>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/RequestManagerInPlace.ejs
// module id = 412
// module chunks = 0